import { PublicCatalogService } from '../../../catalog-services/public-catalog-service';
/**
 * Class retrieves information about video and website's URL
 * Available data types:
 * 1. Video specific data - information about item and video urls
 * 2. Site url - where is embedded video was copied from
 * USE CASE: embedded environment only!
 * @doc PublicEmbed
 */
export class PublicEmbed extends PublicCatalogService {
    /**
     * Returns urls to play
     * @param {string} videoId
     * @param {string} channelId
     * @param {string} instanceId
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<VideoUrls>>}
     */
    getVideoUrls(videoId, channelId, instanceId, requestConfig) {
        return this.get(`/public/embed/play/${videoId}`, {
            params: {
                channel_id: channelId,
                instance_id: instanceId,
            },
            ...requestConfig,
        });
    }
    /**
     * Returns information about specific item in catalog
     * @param {string} videoId
     * @param {string} channelId
     * @param {string} instanceId
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<EmbedVideo>>}
     */
    getVideoInfo(videoId, channelId, instanceId, requestConfig) {
        return this.get(`/public/embed/lists/${channelId}/items/${videoId}/info`, {
            params: {
                instance_id: instanceId,
            },
            ...requestConfig,
        });
    }
    /**
     * Get site url based on instanceId
     * @param {string} instanceId
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<PublicSiteUrl>>}
     */
    getSiteUrlByInstanceId(instanceId, requestConfig) {
        return this.get(`/public/embed/instance/${instanceId}/info`, {
            params: {
                instance_id: instanceId,
            },
            ...requestConfig,
        });
    }
    /**
     * Fetch channel for embed video,
     * does the same as PrivateChannel.fetchPublicSingleChannel, but with instanceId passed to query params
     * @param channelId
     * @param instanceId
     * @param requestConfig
     */
    getChannelInfo(channelId, instanceId, requestConfig) {
        return this.get(`/public/embed/lists/${channelId}/info`, {
            params: {
                instance_id: instanceId,
            },
            ...requestConfig,
        });
    }
    /**
     * Get list of video cards for given video in channel,
     * does the same as PublicVideoCards.getList, but with instanceId passed to query params
     * @param channelId
     * @param videoId
     * @param instanceId
     * @param requestConfig
     */
    getVideoCards(channelId, videoId, instanceId, requestConfig) {
        return this.get(`/public/embed/lists/${channelId}/items/${videoId}/actions`, {
            params: {
                instance_id: instanceId,
            },
            ...requestConfig,
        });
    }
}
//# sourceMappingURL=embed.js.map